import $ from "jquery";
import AlertingApp from './popin/alerting';
import GmsApp from './popin/gms';
import PopinProfileApp from './popin/popinProfile';
import PopinNavProPriApp from "./popin/popinNavProPri";
import MobileNotifBurger from './popin/generic/notifBurger';
import AlertingProApp from "./popin/alerting_pro";
import ActivationEnt from "./popin/activation_ent";
import {MARKET} from 'Utils/market.constants';

("use strict");

// Apps
var popinProfileApp,
    popinNavProPriApp,
    mobileNotifBurger,
    gmsApp = null

// for Alerting & GMS
const SELECTOR = {
    ID_ALERTING_COUNTER: "js-counter-alerting",
    ID_GMS_COUNTER: "js-counter-gms"
};

const UTIL = {
    MOBILE_BREAKPOINT : 768
}

/*
    Global function to update Notifications of alerting and GMS
 */
export function processLhsNotifications() {

    mobileNotifBurger = new MobileNotifBurger();

    // default PRI
    switch (MARKET.CODE) {
        case 2:
            // init Notif of alerting PRO
            if (window.cmsGlobals.alertingProConfig.activate) {
                new AlertingProApp();
            }
            break;
        case 3:
            // init Notif of alerting
            if (window.cmsGlobals.alertingProConfig.activate) {
                new AlertingProApp();
            }
            // init Activation Counter
            if (window.cmsGlobals.activationEntConfig.activate && $( "li[data-channelid='c4dc0026fc78d610VgnVCM100000da4658c0RCRD'] a" ).length ) {
                new ActivationEnt();
            }
            break;
        default:
            // init Notif of alerting
            var selectorIdCounter = document.getElementById(SELECTOR.ID_ALERTING_COUNTER);
            if (window.cmsGlobals.alertingConfig.activate && selectorIdCounter !== null) {
                new AlertingApp();
            }

            // init Activation Tel
            if (window.cmsGlobals.popinProfileConfig.activate) {
                popinProfileApp = new PopinProfileApp();
                popinProfileApp.initPopinProfile();
            }
            break;
    }

    if(MARKET.CODE === 1 || MARKET.CODE === 2){
        popinNavProPriApp = new PopinNavProPriApp();
        popinNavProPriApp.initPopinNavProPri();
    }

    // init Notif of gms
    if (window.cmsGlobals.gmsConfig.activate) {
        var selectorGMSCounter = document.getElementById(SELECTOR.ID_GMS_COUNTER);
        if(MARKET.CODE === 1){
            if (selectorGMSCounter !== null) {
                gmsApp = new GmsApp();
            }
        }else{
            gmsApp = new GmsApp();
        }
    }

}


// WEBPACK FOOTER //
// ./src/js/cms/commons/loginbox/counters.js